export default __webpack_public_path__ + "static/media/logo.a5ebff89.svg";